//hooks
import { useState, useEffect, useRef } from 'react';
import { useApi } from '../hooks/useApi';

//mui
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { GetNotificationListApi } from '../api/notificationList/GetNotificationListApi';
import { CardContent, CircularProgress, Typography } from '@mui/material';

//mui icons
import IconButton from '@mui/material/IconButton';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ReplayIcon from '@mui/icons-material/Replay';

//translate
import { useTranslation } from 'react-i18next';

//api

import { notificationListType } from '../api/notificationList/type/NotificationListType';
import { PostNotificationReadApi } from '../api/notificationList/PostNotificationReadApi';

//utilis
import { formatDateTimeUTC } from '../utils/formatDateTime';


const ITEM_HEIGHT = 48;

const NotificationList = () => {
    
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const [notificationList, setNotificationList] = useState<notificationListType[]>([]);
    const [selected, setSelected] = useState<notificationListType | null>(null);
    const [page, setPage] = useState<number>(1);
    const [lastPage, setLastPage] = useState<number>(1);
    const carsPerPage = 25;
    const [initialLoading, setInitialLoading] = useState<boolean>(true);
    const [initialError, setInitialError] = useState<boolean>(false);
    const loaderRef = useRef<HTMLDivElement | null>(null);

    const {
        loading: notificationListLoading,
        error: notificationListError,
        HandlerApi: notificationlistApi,
    } = useApi(GetNotificationListApi, "GET");
    const {
        loading: notificationReadLoading,
        error: notificationReadError,
        HandlerApi: notificationReadApi,
    } = useApi(PostNotificationReadApi, "Post");

    //start functions

    const handleClick = async (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleRead = async (option: notificationListType) => {
        setSelected(option);
        if(option.is_read === false) {
            let result: any = await notificationReadApi(option.id);
            if(result.code == 200) {
                setInitialLoading(true);
                setInitialError(false);
                const newPage = 1;
                setPage(1);
                let notificationsList = await notificationlistApi({page: newPage, per_page: carsPerPage});
                setLastPage(notificationsList.data.last_page);
                setInitialLoading(false);
                setInitialError(false);
                setNotificationList(notificationsList.data.data);
                setSelected(null);
            }
        }
        else {
         return   
        }
    };

    const fetchDataToReplay = async (page: number) => {
        if(page === 1) {
        setInitialLoading(true)
        }
        try {
        const resultBestCars = await notificationlistApi({page: page, per_page: carsPerPage});
        setLastPage(resultBestCars.data.last_page);
        setNotificationList((prev: any) => {
            const newNotifications = resultBestCars.data.data;
            const filteredPrev = prev.filter((car:any) => !newNotifications.some((element:any) => element.id === car.id));
            const combined = [...filteredPrev, ...newNotifications];
            return combined;
        });
        setInitialLoading(false);
        setInitialError(false);
        }
        catch (error) {
        setInitialLoading(false);
        if (page === 1) {
            setInitialError(true);
        }
        }
        finally {
        setInitialLoading(false);
        }
    };

    //end functions

    useEffect(() => {
        const fetchData = async (page: number) => {
            if(anchorEl) {
                try {
                    const resultBestCars = await notificationlistApi({page: page, per_page: carsPerPage});
                    setLastPage(resultBestCars.data.last_page);
                    setNotificationList((prev: any) => {
                    const newNotifications = resultBestCars.data.data;
                    const filteredPrev = prev.filter((car:any) => !newNotifications.some((element:any) => element.id === car.id));
                    const combined = [...filteredPrev, ...newNotifications];
                    return combined;
                    });
                    setInitialLoading(false);
                    setInitialError(false);
                }
                catch (error) {
                    setInitialLoading(false);
                    if (page === 1) {
                    setInitialError(true);
                    }
                    else {
                    setInitialError(false);
                    }
                }
                finally {
                    setInitialLoading(false);
                }
                };
            }
        fetchData(page);
    }, [page, anchorEl]);

    useEffect(() => {
        if (!loaderRef.current){
        return;
        }
        else {
        // It watches an element and tells you:“Is this element visible on the screen right now?”
        const observer = new IntersectionObserver((entries) => {
            const firstEntry = entries[0];
            if (
                firstEntry.isIntersecting &&
                !notificationListLoading &&
                page < lastPage &&
                !notificationListError
            ) 
                {
                    setPage((prev) => prev + 1);
                }
            });
        //tells the Intersection Observer:“Watch this element”
        observer.observe(loaderRef.current);
        return () => {
            observer.disconnect(); // تنظيف مهم جدًا
        };
        }
    }, [notificationListLoading]); 

    return (
        <div>
            <IconButton onClick={handleClick}>
                <NotificationsActiveIcon className={anchorEl ? "text-customerColor" : "" } />
                {anchorEl ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                slotProps={{
                    paper: {
                        style: {
                        maxHeight: ITEM_HEIGHT * 10.5,
                        width: '30ch',
                        },
                    },
                    list: {
                        'aria-labelledby': 'long-button',
                    },
                    transition: {
                        onExited: () => {
                            setNotificationList([]);
                            setPage(1);
                            setLastPage(1);
                            setSelected(null);
                            setInitialLoading(true);
                        }
                    }
                }}
            >
                {
                    initialLoading
                    ?
                        <div className='flex justify-center'>
                            <CircularProgress/>
                        </div>
                    :
                    <div>
                        {
                            initialError
                            ?
                                <div className='cursor-pointer flex justify-center'>
                                <ReplayIcon onClick={()=>{
                                    setNotificationList([])
                                    fetchDataToReplay(page)
                                    }} className='!text-[40px]'/>
                                </div>
                            :
                            notificationList.length !== 0
                                ?
                                    <>
                                        <div>
                                            {
                                            notificationList.map((option, index) => (
                                                <MenuItem key={index} onClick={()=>handleRead(option)}>
                                                    <CardContent className={option.is_read ? "shadow-md" : "!bg-gray-200"} sx={{ height: '100%', width: '100%', borderRadius: '10px'}}>
                                                        <Typography component="div" className='!flex !justify-between items-center'>
                                                            <div className='flex items-center gap-2'>
                                                                {option.is_read 
                                                                ? 
                                                                    "" 
                                                                :
                                                                    selected?.id === option.id 
                                                                    ?
                                                                        notificationReadLoading
                                                                            ?
                                                                                <span><CircularProgress size={20}/></span>
                                                                            :
                                                                                notificationReadError
                                                                                    ?
                                                                                        <ReplayIcon onClick={()=>{
                                                                                            notificationReadApi(option.id)
                                                                                            }} className='!text-[20px]'
                                                                                        />
                                                                                    :
                                                                                        ""
                                                                    :
                                                                        <span className='w-[10px] h-[10px] rounded-full bg-customerColor inline-block'></span>
                                                                }
                                                                <span className='sm:text-[13px] max-sm:text-[10px]'>{option.title}</span>
                                                            </div>
                                                            <p className='sm:text-[10px] max-sm:text-[7px]'>{formatDateTimeUTC(option.created_at).timeAgo}</p>
                                                        </Typography>
                                                        <Typography sx={{ 
                                                            color: 'text.secondary', 
                                                            fontSize: 12,
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            }}>
                                                            {option.body}
                                                        </Typography>
                                                    </CardContent>
                                                </MenuItem>
                                            ))
                                            }
                                        </div>
                                        {page < lastPage && <div ref={loaderRef} style={{ height: "10px" }} />}
                                        {notificationListLoading && (
                                            <div className="flex justify-center mt-1">
                                                <CircularProgress size={32}/>
                                            </div>
                                        )}
                                        {notificationListError && (
                                            <div className=" cursor-pointer flex justify-center mt-1">
                                                <ReplayIcon onClick={()=>{
                                                    fetchDataToReplay(page)
                                                    }} className='!text-[40px]'/>
                                            </div>
                                        )}
                                    </>
                                :
                                    <p className='flex justify-center items-center'>{t("no_notification_list_found")}</p>
                        }
                    </div>
                }
            </Menu>
        </div>
    )
}

export default NotificationList